/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypePrelevement } from './TypePrelevement';
import {
    TypePrelevementFromJSON,
    TypePrelevementFromJSONTyped,
    TypePrelevementToJSON,
    TypePrelevementToJSONTyped,
} from './TypePrelevement';
import type { TypeEcheance } from './TypeEcheance';
import {
    TypeEcheanceFromJSON,
    TypeEcheanceFromJSONTyped,
    TypeEcheanceToJSON,
    TypeEcheanceToJSONTyped,
} from './TypeEcheance';
import type { TarifCommandDto } from './TarifCommandDto';
import {
    TarifCommandDtoFromJSON,
    TarifCommandDtoFromJSONTyped,
    TarifCommandDtoToJSON,
    TarifCommandDtoToJSONTyped,
} from './TarifCommandDto';
import type { TypeCommission } from './TypeCommission';
import {
    TypeCommissionFromJSON,
    TypeCommissionFromJSONTyped,
    TypeCommissionToJSON,
    TypeCommissionToJSONTyped,
} from './TypeCommission';

/**
 * Modification d'un frais du tunnel.
 * @export
 * @interface UpdateFraisTunnelCommand
 */
export interface UpdateFraisTunnelCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateFraisTunnelCommand
     */
    natureRemunerationId: string;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof UpdateFraisTunnelCommand
     */
    tarif: TarifCommandDto;
    /**
     * Le bénéficiaire est le courtier connecté ; beneficiairePersonneId est alors ignoré.
     * @type {boolean}
     * @memberof UpdateFraisTunnelCommand
     */
    useConnectedBroker?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateFraisTunnelCommand
     */
    beneficiairePersonneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateFraisTunnelCommand
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {TypePrelevement}
     * @memberof UpdateFraisTunnelCommand
     */
    typePrelevement?: TypePrelevement;
    /**
     * 
     * @type {TypeEcheance}
     * @memberof UpdateFraisTunnelCommand
     */
    typeEcheance?: TypeEcheance;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFraisTunnelCommand
     */
    garantiesExclues?: Array<string>;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof UpdateFraisTunnelCommand
     */
    taxe?: TarifCommandDto;
    /**
     * 
     * @type {TypeCommission}
     * @memberof UpdateFraisTunnelCommand
     */
    typeCommission?: TypeCommission;
    /**
     * 
     * @type {number}
     * @memberof UpdateFraisTunnelCommand
     */
    minimum?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFraisTunnelCommand
     */
    maximum?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFraisTunnelCommand
     */
    _default?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateFraisTunnelCommand
     */
    valeurs?: Array<number>;
    /**
     * Affichage du frais sur la page de tarification (le frais reste compté dans le prix).
     * @type {boolean}
     * @memberof UpdateFraisTunnelCommand
     */
    displayedOnPricing?: boolean;
}



/**
 * Check if a given object implements the UpdateFraisTunnelCommand interface.
 */
export function instanceOfUpdateFraisTunnelCommand(value: object): value is UpdateFraisTunnelCommand {
    if (!('natureRemunerationId' in value) || value['natureRemunerationId'] === undefined) return false;
    if (!('tarif' in value) || value['tarif'] === undefined) return false;
    return true;
}

export function UpdateFraisTunnelCommandFromJSON(json: any): UpdateFraisTunnelCommand {
    return UpdateFraisTunnelCommandFromJSONTyped(json, false);
}

export function UpdateFraisTunnelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFraisTunnelCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'natureRemunerationId': json['natureRemunerationId'],
        'tarif': TarifCommandDtoFromJSON(json['tarif']),
        'useConnectedBroker': json['useConnectedBroker'] == null ? undefined : json['useConnectedBroker'],
        'beneficiairePersonneId': json['beneficiairePersonneId'] == null ? undefined : json['beneficiairePersonneId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'typePrelevement': json['typePrelevement'] == null ? undefined : TypePrelevementFromJSON(json['typePrelevement']),
        'typeEcheance': json['typeEcheance'] == null ? undefined : TypeEcheanceFromJSON(json['typeEcheance']),
        'garantiesExclues': json['garantiesExclues'] == null ? undefined : json['garantiesExclues'],
        'taxe': json['taxe'] == null ? undefined : TarifCommandDtoFromJSON(json['taxe']),
        'typeCommission': json['typeCommission'] == null ? undefined : TypeCommissionFromJSON(json['typeCommission']),
        'minimum': json['minimum'] == null ? undefined : json['minimum'],
        'maximum': json['maximum'] == null ? undefined : json['maximum'],
        '_default': json['default'] == null ? undefined : json['default'],
        'valeurs': json['valeurs'] == null ? undefined : json['valeurs'],
        'displayedOnPricing': json['displayedOnPricing'] == null ? undefined : json['displayedOnPricing'],
    };
}

export function UpdateFraisTunnelCommandToJSON(json: any): UpdateFraisTunnelCommand {
    return UpdateFraisTunnelCommandToJSONTyped(json, false);
}

export function UpdateFraisTunnelCommandToJSONTyped(value?: UpdateFraisTunnelCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'natureRemunerationId': value['natureRemunerationId'],
        'tarif': TarifCommandDtoToJSON(value['tarif']),
        'useConnectedBroker': value['useConnectedBroker'],
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'compteBancaireId': value['compteBancaireId'],
        'typePrelevement': TypePrelevementToJSON(value['typePrelevement']),
        'typeEcheance': TypeEcheanceToJSON(value['typeEcheance']),
        'garantiesExclues': value['garantiesExclues'],
        'taxe': TarifCommandDtoToJSON(value['taxe']),
        'typeCommission': TypeCommissionToJSON(value['typeCommission']),
        'minimum': value['minimum'],
        'maximum': value['maximum'],
        'default': value['_default'],
        'valeurs': value['valeurs'],
        'displayedOnPricing': value['displayedOnPricing'],
    };
}

